import { Controller } from "@hotwired/stimulus";

// Hides the "split value" field when the grouping select is set to a value
// that does not need it (e.g. "season").
export default class extends Controller {
  static targets = ["select", "field"];
  static values = { hideWhen: String };

  connect() {
    this.toggle();
  }

  toggle() {
    const hide = this.selectTarget.value === this.hideWhenValue;
    this.fieldTarget.classList.toggle("hidden", hide);
  }
}
